module.exports = __webpack_public_path__ + "static/media/thumb.298f5ae6.jpeg";